<div
  class="flex w-[66vw] flex-col p-10"
  [ngClass]="{
    'h-[87vh]': showNav === true,
    'h-[77vh]': showNav === false
  }"
>
  <div class="mb-5 flex min-h-9 flex-1 flex-row justify-center text-xl">
    <div class="flex w-1/4 flex-1 flex-row items-center justify-start"> </div>

    <div
      class="text-s1 mx-5 line-clamp-2 flex h-14 max-w-prose flex-shrink-0 flex-grow select-none flex-row flex-wrap justify-center text-center font-semibold"
      >{{ title }}
    </div>

    <div class="flex w-1/4 flex-1 flex-row items-center justify-end"> </div>
  </div>

  <div
    *ngIf="isShowInit === false && showNav === true"
    class="text-s1 mb-10 flex w-full flex-row items-center justify-start"
  >
    <div
      *ngIf="!!ref.data.metricId"
      class="flex flex-1 flex-row items-center justify-start"
    >
      <div
        class="flex h-11 max-w-[850px] flex-1 flex-row items-center space-x-5"
      >
        <div
          class="text-s1 flex flex-shrink-0 select-none items-center text-lg font-semibold"
          >Group by</div
        >

        <form [formGroup]="groupByFieldForm" class="min-w-0 flex-1">
          <ng-select
            #groupMetricBySelect
            [fixNgSelectBottom]="groupMetricBySelect"
            data-cy="groupMetricBySelect"
            class="group-metric-by-select w-full min-w-[2px] text-base"
            [items]="dimensionsPlusEmpty"
            (open)="openGroupMetricBy()"
            [loading]="fieldsListLoading"
            [searchable]="true"
            [searchFn]="filterMetricBySearchFn"
            [clearable]="false"
            (change)="groupMetricByChange()"
            (keyup.esc)="
              $event.stopImmediatePropagation(); groupMetricBySelect.blur()
            "
            (keyup.enter)="
              $event.stopImmediatePropagation(); groupMetricBySelect.blur()
            "
            [dropdownPosition]="'bottom'"
            appendTo="body"
            bindLabel="partLabel"
            bindValue="id"
            formControlName="groupByField"
          >
            <ng-template ng-label-tmp let-item="item">
              <div
                *ngIf="item.partLabel === 'Empty' && item.topLabel === 'Empty'"
              ></div>

              <div class="ml-1 flex flex-row items-center">
                <m-field-result
                  *ngIf="
                    item.partLabel !== 'Empty' || item.topLabel !== 'Empty'
                  "
                  class="h-5 w-5"
                  [size]="2"
                  [fieldClass]="item.fieldClass"
                  [result]="item.result"
                ></m-field-result>

                <m-field-label
                  *ngIf="
                    item.partLabel !== 'Empty' || item.topLabel !== 'Empty'
                  "
                  [column]="item"
                  class="ml-3 flex"
                ></m-field-label>
              </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <div class="ml-1 flex flex-row items-center">
                <m-field-result
                  *ngIf="
                    item.partLabel !== 'Empty' || item.topLabel !== 'Empty'
                  "
                  class="h-5 w-5"
                  [size]="2"
                  [fieldClass]="item.fieldClass"
                  [result]="item.result"
                ></m-field-result>

                <m-field-label
                  [column]="item"
                  class="flex"
                  [ngClass]="{
                    'ml-[32px]':
                      item.partLabel === 'Empty' && item.topLabel === 'Empty',
                    'ml-3':
                      item.partLabel !== 'Empty' || item.topLabel !== 'Empty'
                  }"
                ></m-field-label>
              </div>
            </ng-template>
          </ng-select>
        </form>

        <div class="flex flex-shrink-0 flex-row items-center space-x-5">
          <m-chart-line-icon
            class="h-6 w-6 cursor-pointer"
            [ngClass]="{
              'text-m500': groupMetricChartType === chartTypeEnumLine,
              'text-s500': groupMetricChartType !== chartTypeEnumLine
            }"
            (click)="
              groupMetricChartTypeChange({ newChartType: chartTypeEnumLine })
            "
          ></m-chart-line-icon>

          <m-chart-pivot-table-icon
            class="h-6 w-6 cursor-pointer"
            [ngClass]="{
              'text-m500': groupMetricChartType === chartTypeEnumPivotTable,
              'text-s500': groupMetricChartType !== chartTypeEnumPivotTable
            }"
            (click)="
              groupMetricChartTypeChange({
                newChartType: chartTypeEnumPivotTable
              })
            "
          ></m-chart-pivot-table-icon>
        </div>
      </div>
    </div>

    <div class="flex flex-1 flex-row items-center justify-end">
      <div *ngIf="!!query" class="ml-5 flex flex-row items-center justify-end">
        <m-query-status
          [query]="query"
          [showDataRowsLength]="true"
          [showLastCompleteDuration]="true"
          [completedWord]="'Completed'"
        ></m-query-status>
      </div>

      <!-- <div
        *ngIf="!!mconfig && mconfig.warnSelect.length > 0"
        class="text-p500 ml-5 flex h-8 w-8 flex-shrink-0"
        tp="Warning: The selected fields [{{
          mconfig.warnSelect.join(', ')
        }}] may use unsafe aggregations and produce incorrect results"
        placement="left"
      >
        <m-exclamation-icon></m-exclamation-icon>
      </div> -->

      <button
        data-cy="chartDialogRunButton"
        class="text-m0 ml-5 flex h-12 w-24 flex-shrink-0 select-none items-center justify-center rounded text-base font-medium focus:outline-none"
        [ngClass]="{
          'bg-s400 cursor-default':
            isRunButtonPressed === true || query?.status === queryStatusRunning,
          'bg-m600 cursor-pointer':
            isRunButtonPressed === false && query?.status !== queryStatusRunning
        }"
        (click)="run()"
        [disabled]="
          isRunButtonPressed === true || query?.status === queryStatusRunning
        "
      >
        <div>Run</div>

        <!-- <div *ngIf="isRunButtonPressed === true">
          <div class="relative h-9 w-9">
            <ngx-spinner
              [name]="chartDialogRunButtonSpinnerName"
              color="#0084d1"
              bdColor="#00000000"
              size="default"
              type="ball-clip-rotate"
              [fullScreen]="false"
              [disableAnimation]="true"
              [zIndex]="10"
            >
            </ngx-spinner>
          </div>
        </div> -->
      </button>

      <ng-template #templateChartDialogExplore>
        <div *ngIf="isExplorer === false">Explorer role required</div>
        <div *ngIf="isExplorer === true && canAccessModel === false"
          >No access to model</div
        >
      </ng-template>

      <div
        class="ml-5"
        [tp]="templateChartDialogExplore"
        [tpIsEnabled]="isExplorer === false || canAccessModel === false"
      >
        <button
          data-cy="chartDialogExploreButton"
          class="text-m0 h-12 select-none rounded px-6 text-base font-medium focus:outline-none"
          [ngClass]="{
            'bg-m600 cursor-pointer':
              isExplorer === true && canAccessModel === true,
            'bg-s400 cursor-default':
              isExplorer === false || canAccessModel === false
          }"
          [disabled]="isExplorer === false || canAccessModel === false"
          (click)="explore($event)"
        >
          Explore
        </button>
      </div></div
    >
  </div>

  <div
    *ngIf="
      isShowInit === false &&
      mconfig?.fields?.length > 0 &&
      isSelectValid === true &&
      mconfig?.chart.isValid === true
    "
    class="flex h-full w-full flex-grow flex-row overflow-auto"
    [ngClass]="{
      'justify-center':
        (mconfig?.chart.type !== chartTypeEnumTable &&
          mconfig?.chart.type !== chartTypeEnumPivotTable) ||
        query?.lastCompleteTs <= 1,
      'justify-start':
        query?.lastCompleteTs > 1 &&
        (mconfig?.chart.type === chartTypeEnumTable ||
          mconfig?.chart.type === chartTypeEnumPivotTable)
    }"
  >
    <m-chart-view
      class="h-full w-full overflow-auto rounded"
      [ngClass]="{
        'pt-3': mconfig?.chart.type === chartTypeEnumTable,
        'max-w-max':
          (mconfig?.chart.type === chartTypeEnumTable ||
            mconfig?.chart.type === chartTypeEnumPivotTable) &&
          mconfig?.chart.isValid === true &&
          qData?.length > 0,
        'border-s300 aspect-[3/1] border':
          mconfig?.chart.type !== chartTypeEnumTable &&
          mconfig?.chart.type !== chartTypeEnumPivotTable,
        'pb-6 pt-5': mconfig?.chart.type !== chartTypeEnumTable
      }"
      [modelType]="mconfig?.modelType"
      [mconfigFields]="mconfig?.fields"
      [mconfigTimezone]="mconfig?.timezone"
      [isTableHeaderWide]="false"
      [qData]="qData"
      [chart]="mconfig?.chart"
      [isAnimation]="false"
      [isStoreModel]="mconfig?.modelType === modelTypeStore"
      [queryStatus]="query?.status"
      [chartInstanceId]="'chart-dialog-mconfig-id-' + mconfig?.mconfigId"
    ></m-chart-view>
  </div>

  <div
    *ngIf="isShowInit === false"
    class="mt-10 flex flex-row"
    [ngClass]="{
      'max-h-[24%] min-h-[24%]':
        showNav === true &&
        (mconfig?.chart.type === chartTypeEnumLine ||
          mconfig?.chart.type === chartTypeEnumBar ||
          mconfig?.chart.type === chartTypeEnumScatter),
      'max-h-[23%] min-h-[23%]':
        showNav === true &&
        mconfig?.chart.type !== chartTypeEnumLine &&
        mconfig?.chart.type !== chartTypeEnumBar &&
        mconfig?.chart.type !== chartTypeEnumScatter,
      'max-h-[29%] min-h-[29%]':
        showNav === false &&
        (mconfig?.chart.type === chartTypeEnumLine ||
          mconfig?.chart.type === chartTypeEnumBar ||
          mconfig?.chart.type === chartTypeEnumScatter),
      'max-h-[28%] min-h-[28%]':
        showNav === false &&
        mconfig?.chart.type !== chartTypeEnumLine &&
        mconfig?.chart.type !== chartTypeEnumBar &&
        mconfig?.chart.type !== chartTypeEnumScatter
    }"
  >
    <div
      *ngIf="isData === true && mconfig?.fields?.length > 0"
      class="flex w-full max-w-max flex-1 overflow-auto"
    >
      <m-main-table
        class="block h-full w-full"
        [isTableHeaderWide]="false"
        [isEdit]="false"
        [isFormat]="isFormat"
        [mconfig]="mconfig"
        [qData]="qData"
        [mconfigFields]="mconfig?.fields"
      ></m-main-table>
    </div>

    <div
      class="ml-10 flex flex-shrink-0 flex-row items-start"
      *ngIf="mconfig?.filters.length > 0"
    >
      <m-bricks
        class="flex max-h-[150px] max-w-max overflow-auto"
        [extendedFilters]="mconfig.extendedFilters"
        [listen]="ref.data.listen"
        [isKeepBackgroundColor]="false"
      ></m-bricks>
    </div>

    <div
      class="border-s300 ml-10 flex max-h-[150px] min-w-0 flex-1 overflow-auto rounded border bg-white p-3"
      *ngIf="isGivens === true"
    >
      <pre class="text-s1 text-sm leading-6">{{ appliedGivensJson }}</pre>
    </div>
  </div>

  <div
    class="mt-7 flex w-full cursor-default flex-row items-center justify-end"
    *ngIf="isShowInit === false"
  >
    <div
      *ngIf="isData === true && mconfig?.fields?.length > 0"
      class="flex h-11 cursor-pointer flex-row items-center"
      (click)="toggleFormat()"
    >
      <div class="text-s1 flex h-11 select-none items-center text-base"
        >Format
      </div>

      <ui-switch
        class="mb-1 ml-5 flex flex-row items-center"
        [checked]="isFormat"
        color="#64BD63"
      ></ui-switch>
    </div>

    <div
      class="ml-10 cursor-pointer select-none text-lg focus:outline-none"
      (click)="toggleGivens()"
      [ngClass]="{
        'text-s400': isGivens === false,
        'text-green-600': isGivens === true
      }"
      >GIVENS</div
    >

    <div class="ml-10 flex flex-row items-center">
      <div class="text-s400 select-none text-base font-semibold">Model:</div>

      <ng-template #templateChartDialogModel>
        <div *ngIf="isExplorer === false">Explorer role required</div>
        <div *ngIf="isExplorer === true">No access to model</div>
      </ng-template>

      <div
        class="ml-2 flex flex-row items-center"
        [tp]="templateChartDialogModel"
        [tpIsEnabled]="canAccessModel === false"
      >
        <div
          (click)="goToModel(mconfig.modelId, canAccessModel)"
          class="group select-none text-base focus:outline-none"
          [ngClass]="{
            'hover:text-m500 cursor-pointer': canAccessModel === true,
            'cursor-default': canAccessModel === false
          }"
        >
          <span class="ml-[5px] font-semibold">{{
            mconfig?.modelLabel | capitalize
          }}</span>

          <span
            class="text-s400 ml-[5px]"
            [ngClass]="{
              'group-hover:text-m500 cursor-pointer': canAccessModel === true,
              'cursor-default': canAccessModel === false
            }"
            >- {{ query?.connectionType }}</span
          >
        </div>

        <m-lock-closed-icon
          class="text-s400 mb-1 ml-2"
          *ngIf="canAccessModel === false"
        ></m-lock-closed-icon>
      </div>
    </div>

    <div class="ml-10 flex flex-row items-center">
      <div class="text-s400 select-none text-base font-semibold">Timezone:</div>

      <div class="text-s400 ml-2 select-none text-base focus:outline-none">{{
        mconfig?.timezone | capitalize
      }}</div>
    </div>
  </div>
</div>

<div *ngIf="isExplorer$ | async"></div>
